var CONFUSEDCORE = CONFUSEDCORE || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

(function ($) {

    CONFUSEDCORE.addErrorIndication = function (fieldIds) {

        $.each(fieldIds, function (index, fieldId) {

            var $fieldWithError = $('#' + fieldId),
                $labelWithError = $('label[for=' + fieldId + ']'),
                errorMessageId = fieldId + '-error',
                $errorMessage = $('#' + errorMessageId);

            if ($errorMessage.length > 0) {
                $errorMessage.addClass(CSSCONSTANTS.errorMessageClass);
                $fieldWithError.attr('aria-described-by', errorMessageId);
            }

            $fieldWithError.attr('aria-invalid', 'true');
            $fieldWithError.addClass(CSSCONSTANTS.fieldErrorClass);
            $labelWithError.addClass(CSSCONSTANTS.labelErrorClass);

        });

    };

    CONFUSEDCORE.removeErrorIndication = function (fieldIds) {

        $.each(fieldIds, function (index, fieldId) {

            var $fieldWithError = $('#' + fieldId),
                $labelWithError = $('label[for=' + fieldId + ']'),
                errorMessageId = fieldId + '-error',
                $errorMessage = $('#' + errorMessageId);

            if ($errorMessage.length > 0) {
                $errorMessage.removeClass(CSSCONSTANTS.errorMessageClass);
                $fieldWithError.removeAttr('aria-described-by');
            }

            $fieldWithError.removeAttr('aria-invalid');
            $fieldWithError.removeClass(CSSCONSTANTS.fieldErrorClass);
            $labelWithError.removeClass(CSSCONSTANTS.labelErrorClass);

        });

    };
        
})(window.jQuery);